import { Link } from "@tanstack/react-router";
import heroAsset from "@/assets/hero-sporting-life.png.asset.json";

export function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden">
      {/* Background image */}
      <img
        src={heroAsset.url}
        alt="Coyote Creek lifestyle — premium Texas headwear in the field"
        className="absolute inset-0 h-full w-full object-cover object-[85%_center] md:object-[80%_center] lg:object-center"
        width={1920}
        height={804}
        fetchPriority="high"
        decoding="async"
      />
      {/* Left-to-right readability gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/35 to-transparent" />

      {/* Content — bottom-left aligned across all viewports */}
      <div className="relative z-10 mx-auto flex min-h-[340px] w-full max-w-[1400px] items-end px-6 pb-5 pt-6 md:min-h-[460px] md:px-10 md:pb-8 md:pt-10">
        <div className="max-w-[560px] text-left">
          <h1 className="font-heading text-xl font-black uppercase leading-[1.05] tracking-tight text-[#F5EFE2] md:text-4xl lg:text-[44px]">
            Built for the Sporting Life
          </h1>
          <p className="mt-2 max-w-md font-body text-[12px] leading-snug text-[#F5EFE2]/85 md:mt-4 md:text-base md:leading-normal">
            Premium sporting hats engineered to fit your lifestyle.
          </p>
          <Link
            to="/collections/$collection"
            params={{ collection: "all-hats" }}
            className="group mt-4 inline-flex items-center gap-2 border-b-2 border-[#F5EFE2] pb-1 font-ui text-[11px] font-extrabold uppercase tracking-[0.2em] text-[#F5EFE2] transition-colors duration-200 hover:border-[#FA5021] hover:text-[#FA5021] md:mt-8 md:text-sm"
          >
            Shop Now
            <span
              aria-hidden="true"
              className="transition-transform duration-200 group-hover:translate-x-1"
            >
              →
            </span>
          </Link>
        </div>
      </div>
    </section>
  );

}
